module.exports = __webpack_public_path__ + "img/icon.d82c0ef5.png";